jQuery(document).ready(function ($) {
  $('.image-video-slider').slick({
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i data-feather="chevron-left"></i></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i data-feather="chevron-right"></i></button>',
    arrows: true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
});
